<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-dialog v-model="dialog" persistent :width="400">
        <v-card>
          <v-card-title class="secondary white--text">
            Add Service
            <v-spacer></v-spacer>
            <v-btn dark icon @click="dialog=false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <edit-service v-model="new_service"></edit-service>
          <v-card-actions class="grey lighten-3">
            <v-spacer></v-spacer>
            <v-btn
              @click="addItem"
              :loading="adding"
              :disabled="!new_service.title || !new_service.preview.url || !new_service.preview.thumbnail"
              color="success"
            >Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="edit_dialog" persistent :width="400">
        <v-card>
          <v-card-title class="secondary white--text">
            Edit Service
            <v-spacer></v-spacer>
            <v-btn dark icon @click="edit_dialog=false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <edit-service v-model="selected_item"></edit-service>
          <v-card-actions class="grey lighten-3">
            <v-spacer></v-spacer>
            <v-btn @click="saveItem(selected_item)" :loading="saving" color="success">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card style="min-height:85vh" class="admin_secondary">
            <v-card-title class="secondary white--text">
              Editing Services
              <v-spacer></v-spacer>
              <v-btn fab small color="green" class="mr-4" dark @click="dialog=true">
                <v-icon>fa-plus</v-icon>
              </v-btn>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
            </v-card-title>
            <v-container class="white--text">
              <v-row align="center" justify="space-between">
                <v-col cols="12" md="4" lg="3" xl="2">
                  <v-text-field
                    v-model="search"
                    append-icon="fa-search"
                    dark
                    label="Search"
                    outlined
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="3" xl="2" class="text-right">
                  <v-btn small color="error" fab v-if="selected.length" @click="deleteSelected">
                    <v-icon small>fa-trash</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="items"
                :search="search"
                v-model="selected"
                show-select
              >
                <template v-slot:item.title="{ item }">{{item.title}}</template>
                <template v-slot:item.edit="{ item }">
                  <v-btn icon @click="editItem(item)">
                    <v-icon>fa-edit</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import headers from "@/assets/table_headers/admin_editing_services.json";
import editService from "./service";

export default {
  name: "AdminEditingServices",
  components: {
    editService
  },
  data() {
    return {
      dialog: false,
      edit_dialog: false,
      headers: headers,
      items: [],
      search: "",
      loading: false,
      adding: false,
      saving: false,
      selected: [],
      selected_item: null,
      new_service: {
        title: "",
        description: "",
        preview: {
          url: "",
          thumbnail: ""
        },
        price: {
          base: 200,
          video: 17,
          photo: 5,
          document: 3
        }
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    editItem(item) {
      this.selected_item = item;
      this.edit_dialog = true;
    },
    async saveItem(item) {
      this.saving = true;
      try {
        await this.$api.patch(`/admin/editing/services/${item.id}`, item);
        this.edit_dialog = false;
        this.load();
      } catch (ex) {
        alert(ex.error);
      }
      this.saving = false;
    },
    async addItem() {
      this.adding = true;
      try {
        await this.$api.post(`/admin/editing/services`, this.new_service);

        this.dialog = false;
        this.new_service.title = "";
        this.new_service.description = "";
        this.new_service.preview.url = "";
        this.new_service.preview.thumbnail = "";
        this.load();
      } catch (ex) {
        alert(ex.error);
      }
      this.adding = false;
    },
    async deleteSelected() {
      if (!confirm("Sure you want to delete all selected items ?")) {
        return;
      }
      this.loading = true;
      try {
        await Promise.all(
          this.selected.map(
            function(i) {
              return this.deleteItem(i);
            }.bind(this)
          )
        );
        this.selected = [];
        this.load();
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async deleteItem(item) {
      try {
        await this.$api.delete(`/admin/editing/services/${item.id}`);
      } catch (ex) {
        alert(ex.error);
      }
    },
    async load() {
      this.loading = true;
      try {
        this.items = await this.$api(`/admin/editing/services`);
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>